import React, { Fragment } from 'react';

import { Card, CardContent, CardHeader, Feed, FeedEvent, FeedLabel, FeedContent, FeedSummary, FeedDate, FeedExtra } from 'semantic-ui-react'

export function ConcertCard(props) {
  let formatted_date = new Date(props.date).toLocaleDateString("en-GB", { weekday: "long", year: "numeric", month: "long", day: "numeric"})
  let color = 'orange';
  let dayOfWeek = new Date(props.date).getDay();
  if(dayOfWeek === 1) { color = 'teal'; }
  if(dayOfWeek === 2) { color = 'purple'; }
  if(dayOfWeek === 3) { color = 'green'; }
  if(dayOfWeek === 4) { color = 'yellow'; }
  if(dayOfWeek === 5) { color = 'red'; }
  if(dayOfWeek === 6) { color = 'pink'; }

  let shows_by_col = [];
  if(props.concerts) {
    shows_by_col = props.concerts.sort(
      (a,b) => a['time'] !== b['time'] ? a['time'].localeCompare(b['time']) : a['sortable'].localeCompare(b['sortable'])
    ).reduce((resultArray, item, index) => { 
      const chunkIndex = Math.floor(index/5);
      if(!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []
      }
      resultArray[chunkIndex].push(item)
      return resultArray
    }, []);
  } else if (props.single_concert) {
    shows_by_col[0] = [props.single_concert];
    formatted_date = new Date(props.single_concert.date).toLocaleDateString("en-GB", { weekday: "long", year: "numeric", month: "long", day: "numeric",})
  }

  let cols = shows_by_col.length;
  if(cols === 0) {
    cols = 1;
  }
  let width = 320 * cols;
  return (
    <Card key={props.date}
      color={color}
      style={{width: width + 'px'}}
    >
      <CardContent>
        <CardHeader>{formatted_date}</CardHeader>
        <div className="card_feeds">
          {shows_by_col.map(function(array_for_concert, i) {
            return <Feed key={formatted_date + '_' + i}>
              {array_for_concert.map(function(concert) {
                return <FeedEvent key={concert.concert_id} concert_id={concert.concert_id}>
                  <FeedLabel>{concert.time}</FeedLabel>
                  <FeedContent>
                    <FeedSummary>
                      {concert.act && 
                        <><a href={'/act/' + concert.act.act_id} key={concert.act.act_id}>{concert.act.name}</a>
                        {concert.act2 && 
                          <>, <a href={'/act/' + concert.act2.act_id} key={concert.act2.act_id}>{concert.act2.name}</a></>
                        }
                        : </>
                      }
                      {concert.artists && concert.artists.map(function(artist, i) {
                        return <Fragment key={artist.artist_id}>{i > 0 && <>, </>}<a href={'/artist/' + artist.artist_id} key={artist.artist_id}>{'first_name' in artist && <>{artist.first_name} </>}{artist.last_name}</a></Fragment>
                      })}
                    </FeedSummary>
                    {concert['accompaniments'] && 
                      <FeedDate>
                        with {concert['accompaniments'].map(function(accompaniment, i) {
                          return <Fragment key={accompaniment.accompaniment_id}>{i > 0 && <>, </>}{accompaniment.name} ({accompaniment.role})</Fragment>
                        })}
                      </FeedDate>
                    }
                    {concert.show && 
                      <FeedDate>
                        {concert.show.name}
                      </FeedDate>
                    }
                    {concert.festival && 
                      <FeedDate>
                        {concert.festival.name}
                      </FeedDate>
                    }
                    <FeedExtra>
                      {concert.location && 
                        <span>{concert.location.name}</span>
                      }
                    </FeedExtra>
                  </FeedContent>
                </FeedEvent>
              })}
            </Feed>
          })}
        </div>
        {shows_by_col.length === 0 &&
          <div style={{ textAlign: 'center', marginTop: '10px' }}>
            <p>No concerts found</p>
          </div>
        }
      </CardContent>
    </Card>
  );
}